export default __webpack_public_path__ + "static/media/women-are-back-pain-used-hand-support-waist (1).fa7887aa.jpg";